import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate } from "../../util/global";

const PrescriptionTable = ({ data, openedit, openview }) => {

  useEffect( () => {

  }, [data]);

  return (
    <table className="grid">
      <thead>
        <tr >
          <th style={{width:'50px',}}></th>
          <th style={{width:'100px',}}>date</th>
          <th style={{width:'100px',}}>patient</th>
          <th>medicine</th>
          <th>dosage</th>
          <th>instructions</th>
          <th>status</th>
          <th>end date</th>
          </tr>
      </thead>
      <tbody>
        {data.map((p, i) => {
          // Guard clause to ensure medicinedata exists
          const medicines = p.medicinedata || [];
          
          return medicines.map((med, midx) => {
            // Logic to extract days from instructions (e.g., "5 days twice daily")
            const daysmatch = med.instructions?.match(/^[0-9]+/);
            const days = daysmatch ? parseInt(daysmatch[0]) : 0;
            
            let enddatestr = "-";
            let status = "-";

            if (days > 0 && p.datetime) {
              const startdate = getdate(p.datetime).date;
              const enddate = new Date(startdate.getTime() + (days * 24 * 60 * 60 * 1000));
              enddatestr = formatdate(enddate);
              const msleft = enddate.getTime() - Date.now();
              const daysleft = Math.ceil(msleft / (24 * 60 * 60 * 1000));
              if (msleft < 0)        status = "ended";
              else if (daysleft <= 3) status = "expiring";
              else                    status = "ongoing";
            }

            return (
              <tr key={`${p._id || i}-${midx}`} style={{ cursor: 'pointer' }}>
                {/* Institutional-Grade rowSpan logic: 
                   Only render the first 3 columns for the first medicine row of a prescription
                */}
                {midx === 0 && (
                  <>
                    <td rowSpan={medicines.length}>
                      <select 
                        className="action-select" 
                        value="" 
                        onChange={(e) => {
                          if (e.target.value === "View") openview("prescription", p);
                        }}
                      >
                        <option value="" disabled>{i + 1}</option>
                        <option value="View">View</option>
                      </select>
                    </td>
                    <td rowSpan={medicines.length} style={{ whiteSpace: 'nowrap' }}>{p.datetime}</td>
                    <td rowSpan={medicines.length} style={{ whiteSpace: 'nowrap' }}>{p.name}</td>
                  </>
                )}
             
                <td style={{ whiteSpace: 'nowrap' }}>{med.medicine}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{med.dosage}</td>
                <td>{med.instructions}</td>
                <td>
                  <span className={`status-badge ${status}`}>
                    {status}
                  </span>
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>{enddatestr}</td>
              </tr>
            );
          });
        })}
      </tbody>
    </table>
  );
};

export default PrescriptionTable;